import { useToast, chakra, Button, Text, useDisclosure, Box } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import { createSenderID } from '../../../API/account/senderId';
import { toaster } from '../../../utils/toast';
import FormInput from '../../UI/form/FormInput';
import { initiateVerifyDomain } from '../../../API/account/domains';
import ConfirmDomainEmail from './ConfirmDomainEmail';
import CustomModal from '../../UI/CustomModal';

const VerifyDomain: FC<{ verifyClose: () => void, domainUid: string }> = ({ verifyClose,domainUid }) => {
  const [email, setEmail] = useState('');

  const confirmDomainEmailDisclosure = useDisclosure();

  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(initiateVerifyDomain, {
    onSuccess(data) {
      const success = { ...data }
      toaster(toast, success)
      queryClient.invalidateQueries(['domainData']);
      confirmDomainEmailDisclosure.onOpen()
      // verifyClose()
    },
 
    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors)
    },
  });

  return (
    <Box>
    <chakra.form
      onSubmit={(e) => {
        e.preventDefault();

        mutate({email, domainUid});
      }}
      marginTop={"20px"}
    >
      <FormInput
        label='Email Address'
        type='text'
        for='Domain'
        // tag='Add yours or you can use our default domain'
        formControlProps={{
          isRequired: true,
        }}
        inputProps={{
          placeholder: 'user@email.com',
          onChange: (e) => {
            setEmail(e.target.value);
          },
          // max: '11',
          // isInvalid: name?.length > 11,
        }}
        // helperText={`mywebsite.com or mail.mywebsite.com, don't include "http://" or "https://"`}
      />

      <Button
        isLoading={isLoading}
        // isDisabled={!name || name?.length > 11}
        w='full'
        colorScheme={'primary'}
        mt='32px'
        mb='40px'
        type='submit'
        // onClick={() => {
        //     close && close();
        //     confirmOpen && confirmOpen()
        // }}
      >
        Send verification email
      </Button>
    </chakra.form>
    <CustomModal
        disclosure={confirmDomainEmailDisclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Confirm email address
          </Text>
        }
      >
        <Text color={"#7489AA"} fontSize={"12px"} fontWeight={500} my={3}>
          Please enter the code sent to the email 
        </Text>
        <ConfirmDomainEmail
          close={confirmDomainEmailDisclosure.onClose}
          domainUid={domainUid}
          email={email}
          verifyClose={verifyClose}
        />
      </CustomModal>
    </Box>
  );
};

export default VerifyDomain;
